<template>
  <div class="perfil-container">
    <div class="perfil-card">
      <h1>Mi Perfil</h1>
      <div class="perfil-content" v-if="perfil">
        <p><strong>Nombre:</strong> {{ perfil.nombre }}</p>
        <p><strong>Correo:</strong> {{ perfil.correo }}</p>
        <p><strong>Celular:</strong> {{ perfil.celular || "No registrado" }}</p>
        <p><strong>Rol:</strong> {{ perfil.rol }}</p>
        <button class="btn-primario" @click="abrirModal">Cambiar Contraseña</button>
      </div>
      <div v-else>
        <p>Cargando datos del perfil...</p>
      </div>
    </div>

    <!-- Modal para cambiar contraseña -->
    <div v-if="mostrarModal" class="modal">
      <div class="modal-content">
        <h2>Cambiar Contraseña</h2>
        <form @submit.prevent="cambiarPassword">
          <div class="input-group">
            <label><strong>Contraseña actual</strong></label>
            <input
              :type="mostrarPasswordActual ? 'text' : 'password'"
              v-model="password_actual"
            />
            <i
              class="toggle-password bi"
              :class="mostrarPasswordActual ? 'bi-eye-slash' : 'bi-eye'"
              @click="togglePassword('actual')"
            ></i>
          </div>
          <div class="input-group">
            <label><strong>Nueva Contraseña</strong></label>
            <input
              :type="mostrarPasswordNueva ? 'text' : 'password'"
              v-model="nuevo_password"
            />
            <i
              class="toggle-password bi"
              :class="mostrarPasswordNueva ? 'bi-eye-slash' : 'bi-eye'"
              @click="togglePassword('nueva')"
            ></i>
          </div>
          <div class="input-group">
            <label><strong>Confirmar Nueva Contraseña</strong></label>
            <input
              :type="mostrarPasswordConfirmar ? 'text' : 'password'"
              v-model="confirmar_password"
            />
            <i
              class="toggle-password bi"
              :class="mostrarPasswordConfirmar ? 'bi-eye-slash' : 'bi-eye'"
              @click="togglePassword('confirmar')"
            ></i>
          </div>
          <div class="modal-actions">
            <button type="submit" class="btn-primario">Actualizar</button>
            <button type="button" class="btn-secundario" @click="cerrarModal">
              Cancelar
            </button>
          </div>
        </form>
        <p v-if="mensaje" :style="{ color: mensaje.error ? 'red' : 'green' }">
          {{ mensaje.texto }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      perfil: null,
      mostrarModal: false,
      password_actual: "",
      nuevo_password: "",
      confirmar_password: "",
      mensaje: null,
      mostrarPasswordActual: false,
      mostrarPasswordNueva: false,
      mostrarPasswordConfirmar: false,
    };
  },
  methods: {
    async cargarPerfil() {
      try {
        const userId = localStorage.getItem("usuario_id");
        const response = await axios.get( this.$backendUrl+ 
     `/perfil.php?id=${userId}`
        );
        this.perfil = response.data;
      } catch (error) {
        console.error("Error al cargar el perfil:", error);
      }
    },
    abrirModal() {
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.resetPasswordFields();
    },
    async cambiarPassword() {
      if (this.nuevo_password !== this.confirmar_password) {
        this.mensaje = { texto: "Las contraseñas no coinciden.", error: true };
        return;
      }

      try {
        const payload = {
          usuario_id: localStorage.getItem("usuario_id"),
          password_actual: this.password_actual,
          nuevo_password: this.nuevo_password,
        };

        const response = await axios.post( this.$backendUrl+ "updateContraseña.php",
          payload
        );

        this.mensaje = { texto: response.data.message, error: false };
        setTimeout(() => this.cerrarModal(), 2000);
      } catch (error) {
        this.mensaje = {
          texto: error.response?.data?.error || "Error desconocido.",
          error: true,
        };
      }
    },
    resetPasswordFields() {
      this.password_actual = "";
      this.nuevo_password = "";
      this.confirmar_password = "";
      this.mensaje = null;
    },
    togglePassword(tipo) {
      if (tipo === "actual") this.mostrarPasswordActual = !this.mostrarPasswordActual;
      if (tipo === "nueva") this.mostrarPasswordNueva = !this.mostrarPasswordNueva;
      if (tipo === "confirmar")
        this.mostrarPasswordConfirmar = !this.mostrarPasswordConfirmar;
    },
  },
  mounted() {
    this.cargarPerfil();
  },
};
</script>

<style scoped>
/* Estilos principales */
.perfil-container {
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Alineación vertical al principio */
  height: 100vh;
  padding-top: 50px; /* Subir el whitebox */
  background-color: #f4f4f9;
}

.perfil-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 400px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.perfil-card h1 {
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #333;
}

.perfil-content p {
  margin: 10px 0;
  font-size: 1.2rem;
  color: #555;
}

button {
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
}

button.btn-primario {
  background-color: #29b39c;
  color: #fff;
}

button.btn-primario:hover {
  background-color: #249f87;
}

button.btn-secundario {
  background-color: #e5e5e5;
  color: #333;
}

button.btn-secundario:hover {
  background-color: #d4d4d4;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 120%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-content h2 {
  font-size: 1.8rem;
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 20px;
  text-align: left;
}

.input-group label {
  font-size: 1.1rem;
  color: #333;
}

.input-group .password-wrapper {
  position: relative;
}

.input-group input {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 65%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 1.8rem;
  color: #249f87;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>
